// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { Characteritics, KeyFactCell } from '../../../types/OfficesType';
import surfaceImg from '../../../img/factIcon/surface.png';
import peopleImg from '../../../img/factIcon/people.png';
import parkingImg from '../../../img/factIcon/parking.png';
import height from '../../../img/factIcon/height.png';
import number_floors from '../../../img/factIcon/number_floors.png';
import architectImg from '../../../img/factIcon/architectImg.png';
import locationImg from '../../../img/kpi/buildings.png';
import delivery_dateImg from '../../../img/KeyDateImage/special-event.png';
import MarketingFact from '../../mall/data/marketing/MarketingFact';

type Props = {
  characteristics: Characteritics[],
  keyFactCells: ?KeyFactCell[],
}

type State = {
  selected: number,
}

class KeyFacts extends React.Component<Props, State> {
  state: State = {
    selected: 0,
  };

  render() {
    const selectedClass = 'selected';
    const iconsList = {
      surface_area_m2: surfaceImg,
      worksations: peopleImg,
      parking_spaces: parkingImg,
      height_m: height,
      number_floors,
      available_surface_area_m2: surfaceImg,
      average_surface_floor_m2: surfaceImg,
    };
    const iconsKeyFacts = {
      architect: architectImg,
      location: locationImg,
      manager: peopleImg,
      owner: peopleImg,
      delivery_date: delivery_dateImg,
    };
    return (
      <div className="building-description">
        <div className="title">
          <Translate value="OFFICE.FACT_FIGURE" />
        </div>
        <div className="facts-container">
          <div className="key-figures">
            {
              this.props.characteristics
              && (
                this.props.characteristics.map(item => (
                  <MarketingFact
                    key={item.characteristicsType.id}
                    image={iconsList[item.characteristicsType.id]}
                    value={item.value}
                    label={item.characteristicsType.label}
                  />
                ))
              )
            }
          </div>
          {
            this.props.keyFactCells
            && (
              <>
                <div className="hr" />
                <div className="fact-figure">
                  <div className="items-list">
                    {
                      (
                        this.props.keyFactCells.map((item: KeyFactCell, index: number) => (
                          <div className="item" key={item.name}>
                            <button
                              className={`item-circle ${index === this.state.selected ? selectedClass : ''}`}
                              onClick={() => this.setState({ selected: index })}
                            >
                              <img src={iconsKeyFacts[item.icon]} alt="icon" />
                            </button>
                          </div>
                        ))
                      )
                    }
                  </div>

                  {
                    this.props.keyFactCells
                    && (
                      this.props.keyFactCells[this.state.selected]
                      && (
                        <div className="items-details">
                          <div className="title-subtitle">
                            <p className="item">
                              {this.props.keyFactCells[this.state.selected].name}
                            </p>
                          </div>
                          <p className="details">
                            {this.props.keyFactCells[this.state.selected].description}
                          </p>
                        </div>
                      )
                    )
                  }
                </div>
              </>
            )
          }
        </div>
      </div>
    );
  }
}

export default KeyFacts;
